import { render } from "./WarrantyClaimHeader.vue?vue&type=template&id=403e5c66"
import script from "./WarrantyClaimHeader.vue?vue&type=script&lang=js"
export * from "./WarrantyClaimHeader.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__